// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eoev-widget .eoev-chip-group .v-chip{margin:4px 8px 4px 0}", ""]);
// Exports
module.exports = exports;
